import { PERSISTENT_TOAST_DURATION } from '../const/persistent-toast-duration.const'

import { shouldScheduleToastDismiss } from './shouldScheduleToastDismiss'

export const resolveToastViewDuration = (duration?: number): number =>
  shouldScheduleToastDismiss(duration) ? (duration as number) : PERSISTENT_TOAST_DURATION
